import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export default function CompareSlider({
  before,
  after,
  beforeStyle,
  afterStyle,
  ratio = "aspect-[16/10]",
  className = "",
  testId = "compare-slider",
}) {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const update = (clientX) => {
    const r = ref.current.getBoundingClientRect();
    setPos(Math.min(97, Math.max(3, ((clientX - r.left) / r.width) * 100)));
  };

  return (
    <div
      ref={ref}
      data-testid={testId}
      data-cursor="DRAG"
      className={`relative overflow-hidden select-none touch-none border hairline ${ratio} ${className}`}
      onPointerDown={(e) => {
        ref.current.setPointerCapture(e.pointerId);
        update(e.clientX);
      }}
      onPointerMove={(e) => {
        if (e.buttons === 1) update(e.clientX);
      }}
    >
      <img
        src={after}
        alt="After — professionally edited real estate photograph"
        style={afterStyle}
        className="absolute inset-0 w-full h-full object-cover"
        draggable={false}
        loading="lazy"
      />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img
          src={before}
          alt="Before — unprocessed raw capture"
          style={beforeStyle}
          className="absolute inset-0 w-full h-full object-cover"
          draggable={false}
          loading="lazy"
        />
      </div>

      <div className="absolute inset-y-0 pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -left-px w-0.5 bg-gold shadow-[0_0_20px_rgba(212,175,55,0.6)]" />
        <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-11 h-11 rounded-full border border-gold bg-ink/70 backdrop-blur flex items-center justify-center text-gold">
          <MoveHorizontal size={16} />
        </div>
      </div>

      <span className="absolute top-4 left-4 text-[10px] tracking-[0.3em] uppercase bg-ink/60 backdrop-blur px-3 py-1.5 border border-ivory/20 text-ivory/90">
        Before
      </span>
      <span className="absolute top-4 right-4 text-[10px] tracking-[0.3em] uppercase bg-ink/60 backdrop-blur px-3 py-1.5 border border-gold/50 text-gold">
        After
      </span>
    </div>
  );
}
